import { createSlice } from '@reduxjs/toolkit';
import { removeNulls } from 'utils';
const convertIssues = (issues) => {
    return Object.fromEntries(Object.entries(issues).map(([key, value]) => [
        key,
        {
            ...value,
            comments: [],
            attachments: [],
        },
    ]));
};
const commentFromHistoryItem = (item) => {
    if (item.comment == '') {
        return null;
    }
    return {
        time: item.time,
        author: item.author,
        comment: item.comment,
        author_is_support: item.author_is_support,
    };
};
const attachmentFromHistoryItem = (item) => [
    ...item.attachments.map((attach) => ({
        time: item.time,
        author: item.author,
        author_is_support: item.author_is_support,
        attachment: attach,
    })),
];
const mergeWithHistoryItem = (issue, item) => {
    if (issue == null) {
        return {
            ...item,
            comments: removeNulls([commentFromHistoryItem(item)]),
            attachments: attachmentFromHistoryItem(item),
        };
    }
    return {
        ...issue,
        ...item,
        comments: removeNulls([...issue.comments, commentFromHistoryItem(item)]),
        attachments: [...issue.attachments, ...attachmentFromHistoryItem(item)],
    };
};
const slice = createSlice({
    name: 'support/chat',
    initialState: {
        loading: false,
        issues: null,
        selected_issue_id: null,
        error: null,
        login_link: null,
        have_unread_messages: false,
    },
    reducers: {
        createRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        setResponseAllUserIssues: (state, action) => {
            state.issues = convertIssues(action.payload.issues);
            state.loading = false;
            state.have_unread_messages = false;
        },
        setResponseSelectedIssue: (state, action) => {
            state.issues = {
                ...state.issues,
                [action.payload.issue.ticket_id]: action.payload.issue,
            };
            state.selected_issue_id = action.payload.issue.ticket_id;
            state.login_link = action.payload.login_link;
            state.loading = false;
            state.have_unread_messages = false;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        changeIssue: (state, action) => {
            const issues = state.issues ?? {};
            state.issues = {
                ...issues,
                [action.payload.ticket_id]: mergeWithHistoryItem(issues[action.payload.ticket_id], action.payload),
            };
            state.have_unread_messages = true;
        },
        addAttachmentUrl: (state, action) => {
            const issues = state.issues ?? {};
            const issue_for_edit = issues[parseInt(action.payload.issue_id, 10)];
            if (issue_for_edit != null) {
                state.issues = {
                    ...issues,
                    [action.payload.issue_id]: {
                        ...issue_for_edit,
                        attachments: issue_for_edit.attachments.map((attach) => {
                            if (attach.attachment.id ==
                                parseInt(action.payload.attachment_id, 10)) {
                                return {
                                    ...attach,
                                    url: action.payload.url,
                                };
                            }
                            return attach;
                        }),
                    },
                };
            }
        },
        addLoginLink: (state, action) => {
            state.login_link = action.payload;
        },
        commentSend: (state) => {
            state.loading = false;
            state.error = null;
        },
        // addComment: (
        //     state: SupportChatState,
        //     action: PayloadAction<AddOkdeskComment>
        // ) => {
        //     state.issues?.[parseInt(action.payload.issue_id, 10)]?.comments.push({
        //         ...action.payload,
        //         comment: action.payload.content,
        //     });
        //     state.have_unread_messages = true;
        // },
    },
});
export const { createRequest, setResponseSelectedIssue, setResponseAllUserIssues, setError, changeIssue, addLoginLink, addAttachmentUrl, commentSend,
// addComment,
 } = slice.actions;
export const supportChatReducer = slice.reducer;
